<script>
    import windows from "../../stores/windows.js";

    export let window;

    const padding = 20.0;

    let isMouseDown = false;
    let initialMouseLocation;
    let initialWindowSize;

    $: innerWidth = 0;
    $: innerHeight = 0;

    function didClickCloseButton() {
        windows.close(window.id);
    }

    function didMouseDown(e) {
        const x =
            e.touches && e.touches.length ? e.touches[0].clientX : e.clientX;

        const y =
            e.touches && e.touches.length ? e.touches[0].clientY : e.clientY;

        window.isResizing = true;
        isMouseDown = true;
        initialMouseLocation = { x, y };
        initialWindowSize = { ...window };
    }

    function didMouseMove(e) {
        if (!isMouseDown) {
            return;
        }

        const x = e.clientX || e.touches[0].clientX;
        const y = e.clientY || e.touches[0].clientY;

        const offset = {
            x: x - initialMouseLocation.x,
            y: y - initialMouseLocation.y
        };

        windows.resize(
            window.id,
            Math.min(
                Math.max(
                    initialWindowSize.width + offset.x,
                    (window.min && window.min.width) || 0.0
                ),
                Math.min(
                    innerWidth - window.x - padding,
                    (window.max && window.max.width) || Infinity
                )
            ),
            window.sizeToFit
                ? window.height
                : Math.min(
                      Math.max(
                          initialWindowSize.height + offset.y,
                          (window.min && window.min.height) || 0.0
                      ),
                      Math.min(
                          innerHeight - window.y - padding,
                          (window.max && window.max.height) || Infinity
                      )
                  )
        );
    }

    function didMouseUp() {
        isMouseDown = false;
        window.isResizing = false;
        windows.resize(window.id, window.width, window.height);
    }
</script>

<svelte:window
    on:mousemove={didMouseMove}
    on:touchmove={didMouseMove}
    on:mouseup={didMouseUp}
    on:touchend={didMouseUp}
    bind:innerWidth
    bind:innerHeight
/>

<div
    class="resize-handle"
    on:mousedown={didMouseDown}
    on:touchstart={didMouseDown}
>
    <div>
        <hr />
        <hr />
        <hr />
    </div>
</div>

<style>
    .resize-handle {
        position: absolute;
        right: calc(var(--chrome-depth) * 2);
        bottom: calc(var(--chrome-depth) * 2);
        transform: translateY(1px);
        width: 16px;
        height: 16px;
        cursor: nwse-resize;
        z-index: 9090;
    }

    .resize-handle div {
        position: absolute;
        top: calc(var(--chrome-depth) * 2);
        left: calc(var(--chrome-depth) * 2 + 1px);
    }

    div hr {
        position: absolute;
        top: 3px;
        left: -5px;
        width: 14px;
        margin: 0;
        margin-bottom: 5px;
        padding: 0;
        transform: rotate(135deg);
    }

    div hr:nth-child(2) {
        top: 5px;
        left: 0;
        width: 8px;
    }

    div hr:nth-child(3) {
        top: 7px;
        left: 5px;
        width: 2px;
    }
</style>
